module.exports = __webpack_public_path__ + "static/media/feeds.6b077dba.svg";